"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AccountRemoveButton = exports.AccountReconnectButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["name", "email", "avatar", "isActive", "isHoverable", "isError", "isLoading", "reconnect", "remove"],
  _excluded2 = ["isError"];
var AccountListItem = function AccountListItem(_ref) {
  var name = _ref.name,
    email = _ref.email,
    avatar = _ref.avatar,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    _ref$isHoverable = _ref.isHoverable,
    isHoverable = _ref$isHoverable === void 0 ? false : _ref$isHoverable,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    reconnect = _ref.reconnect,
    remove = _ref.remove,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('flex items-center justify-between py-3 -mx-6 px-6 text-sm', {
      'cursor-pointer': isHoverable,
      'bg-secondary': isActive && !isError,
      'hover:bg-secondary': isHoverable && !isError,
      'bg-red': isError,
      'opacity-50': isLoading
    })
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-3"
  }, avatar), /*#__PURE__*/_react["default"].createElement("div", null, name && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('block font-bold break-all', {
      'text-white': isError
    })
  }, name), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])({
      'text-white': isError,
      'text-light': !isError
    }, 'block break-all')
  }, email))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mr-3"
  }, reconnect && /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-3"
  }, reconnect), remove && /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-3"
  }, remove)));
};
var AccountRemoveButton = exports.AccountRemoveButton = function AccountRemoveButton(_ref2) {
  var _ref2$isError = _ref2.isError,
    isError = _ref2$isError === void 0 ? false : _ref2$isError,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    style: isError ? {
      backgroundColor: "rgba(255, 255, 255, 0.2)"
    } : {},
    className: (0, _classnames["default"])('font-bold cursor-pointer p-3', {
      'text-primary': !isError,
      'text-white': isError
    })
  }, rest), t('button.remove'));
};
var AccountReconnectButton = exports.AccountReconnectButton = function AccountReconnectButton(props) {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    style: {
      backgroundColor: 'rgba(255, 255, 255, 0.2)'
    },
    className: "font-bold cursor-pointer text-white p-3"
  }, props), t('button.reconnect'));
};
var _default = exports["default"] = AccountListItem;
//# sourceMappingURL=AccountListItem.js.map